import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-create-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './create-modal.component.html',
  styleUrl: './create-modal.component.css',
})
export class CreateModalComponent implements OnInit {
  @Input() item: any; // Define la propiedad `item` como @Input
  @Input() isOpen: boolean = false; // Controla si el modal está abierto
  @Input() title: string = 'RegistrarEstudiante'; // Título dinámico
  @Input() fields: {
    key: string;
    label: string;
    type: string;
    options?: any[];
  }[] = []; // Campos a mostrar
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<any>();
  showPassword: boolean = false;


  constructor() {}

  ngOnInit() {
    // Inicializa el objeto `item` con valores predeterminados basados en los campos
    this.fields.forEach((field) => {
      this.item[field.key] = ''; // Inicializa cada campo con un valor vacío
    });
  }

  closeModal() {
    this.close.emit();
  }

  updateItem() {
    this.save.emit(this.item); // Emite el objeto `item` con los datos del formulario
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
}
